import { useState } from "react";
import Tabs from "../../components/adminDashboard/ui/userrolemapping/Tabs";
import MappingForm from "../../components/adminDashboard/ui/userrolemapping/MappingForm";
import MappedRoleList from "../../components/adminDashboard/ui/userrolemapping/MappedRoleList";

export default function UserRoleMappingPage() {
  const [activeTab, setActiveTab] = useState("mapping");

  return (
    <div className="ad-content">
      <div className="usecase-wrapper ad-card ad-card-lg">

        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />

        <div className="usecase-content">
          {activeTab === "mapping" ? (
            <MappingForm />
          ) : (
            <MappedRoleList />
          )}
        </div>

      </div>
    </div>
  );
}